import React, { useEffect, useState, useRef, useCallback } from "react";
import { Typography } from "@mui/material";
import Tag from "src/Assets/images/tag.svg";
import DownArrow from "src/Assets/images/UpButton.png";
import "./TagActtivity.css";
import ActivityPost from "../../ActivityPost";
import API from "../../../../network";
import CircularProgress from "@material-ui/core/CircularProgress";
// import ConfirmationDialog from "src/Components/ConfirmationDialog";

function TagActtivity(props) {
  const [isListOpen, setisListOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [breadCountLength, setBreadCountLength] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [completeTagsListData, setCompleteTagsListData] = useState({});
  const [confModalVisible, setConfModalVisible] = useState(null);
  const [activityLoading, setActivityLoading] = useState(false);

  const listRef = useRef(null);

  const toggleList = () => {
    setisListOpen(true);
  };

  const handleScroll = useCallback(() => {
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5 && hasMore) {
      setPageNumber((prevPage) => prevPage + 1);
    }
  }, [hasMore]);

  const getData = async (page) => {
    try {
      setActivityLoading(true);
      const newPage = (page - 1) * 10;
      const res = await API.getUserTags(newPage);

      const hashList = res?.data?.hashList || [];

      if (hashList.length > 0) {
        setListData((prevList) => [...prevList, ...hashList]);
        setBreadCountLength(
          (prevBreadLength) => prevBreadLength + hashList.length
        );
        setHasMore(true);
        setActivityLoading(false);
      } else {
        setHasMore(false);
        setActivityLoading(false);
      }

      setCompleteTagsListData(res.data || {});
    } catch (error) {
      console.error("Error fetching user tags:", error);
      alert("Failed to load data. Please try again later.");
      setHasMore(false);
      setActivityLoading(false);
    }
  };

  useEffect(() => {
    if (props.isCountLoading) return;
    getData(pageNumber);
  }, [props.isCountLoading, pageNumber]);

  const updateParentComponentSayCount = (parentId, operator, filterType) => {
    const newListData = listData.map((item) => {
      if (item.id === parentId) {
        const key = filterType === "activityTag" ? "postCount" : "sayCount";
        const count = item[key] || 0;

        return {
          ...item,
          [key]: operator === "increment" ? count + 1 : Math.max(0, count - 1),
        };
      }
      return item;
    });

    setListData(newListData);
  };

  const updateList = (id, followStatus) => {
    const newData = [...listData];
    const modifiedData = newData.find((x) => x.id === id);
    modifiedData.followStatus = followStatus.includes("0") ? "N" : "Y";
    modifiedData.followCount = followStatus.includes("0")
      ? modifiedData.followCount - 1
      : modifiedData.followCount - 1 + 2;
    setListData(newData);
  };

  const deleteActivityTagPost = (id) => {
    const newData = [...listData];
    const modifiedData = newData.filter((x) => x.id !== id);
    setListData(modifiedData);
  };

  const onClose = () => {
    setConfModalVisible(null);
  };

  const confirmationForDelete = (id) => {
    setConfModalVisible({
      open: true,
      type: "warning",
      title: "Are you sure you want to delete this TAG?",
      rejectLabel: "Cancel",
      acceptLabel: "Yes",
      onReject: onClose,
      onAccept: () => deleteTag(id),
    });
  };

  const deleteTag = (id) => {
    let formdata = new FormData();
    formdata.append("messageID", id);
    API.deleteProfilePost(formdata)
      .then((res) => {
        const newList = [...listData];
        const index = newList.findIndex((x) => x.id === id);
        if (index > -1) {
          newList.splice(index, 1);
          setListData(newList);
          props?.decreaseActivityTagCount?.();
          setCompleteTagsListData((prevState) => ({
            ...prevState,
            hashListSize: prevState?.hashListSize - 1,
          }));
        }
        setConfModalVisible(null);
      })
      .catch((err) => {});
  };

  const updateMessage = useCallback((id, message, locationName, attachment, lat, lng) => {
    const tempUrl =
      attachment instanceof File ? URL.createObjectURL(attachment) : null;
    const urlRegex =
      /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)[^\s]*)/gi;
    const extractedUrls = message ? message.match(urlRegex) || [] : [];

    setListData((prevList) =>
      prevList.map((eachItem) => {
        if (eachItem?.id === id) {
          const { newSelectedLocation, ...cleanItem } = eachItem;
          const cleanUpdatedMsg = (message || "").replace(/<[^>]+>/g, "").trim();
          const cleanDefaultMsg = (eachItem?.Message || "").replace(/<[^>]+>/g, "").trim();
          const isTextModified = cleanUpdatedMsg.length > 0 && cleanUpdatedMsg !== cleanDefaultMsg;
          const isAttachmentAdded = attachment instanceof File;
          const isContentEdited = isTextModified || isAttachmentAdded;

          return {
            ...cleanItem,
            Message: message,
            msg: message,
            url: extractedUrls.length > 0 ? extractedUrls : eachItem?.url,
            locName: locationName || "",
            msgLat: locationName ? (lat || eachItem.msgLat || "") : "",
            msgLng: locationName ? (lng || eachItem.msgLng || "") : "",
            docName:
              attachment?.name ||
              (attachment === null ? "" : eachItem.docName || ""),
            docLocation:
              tempUrl ||
              (attachment === null ? "" : eachItem.docLocation || ""),
            docTagged:
              attachment ? 1 : attachment === null ? 0 : eachItem.docTagged,
            ...(isContentEdited ? { updated_time: "1m", edited: 1 } : {}),
          };
        }
        return { ...eachItem };
      })
    );
  }, []);

  useEffect(() => {
    const handlePostUpdated = (event) => {
      const { id, message, locationName, attachment, lat, lng } = event.detail || {};
      if (id) {
        updateMessage(id, message, locationName, attachment, lat, lng);
      }
    };
    window.addEventListener("postUpdated", handlePostUpdated);
    return () => {
      window.removeEventListener("postUpdated", handlePostUpdated);
    };
  }, [updateMessage]);
    // const newData = [...listData];
    // const modifiedData = newData.find((x) => x.id === id);
    // let formdata = new FormData();
    // formdata.append("messageID", id);
    // formdata.append("message", message);
    // API.updateProfilePost(modifiedData.locName, formdata)
    //   .then((res) => {
    //     modifiedData.Message = message;
    //     setListData(newData);
    //   })
    //   .catch((err) => {});

  const handleDeleteAttachementDocFromParent = (id) => {
    setListData((prevData) =>
      prevData.map((item) =>
        item.id === id
          ? { ...item, docName: null, docLocation: null, docTagged: 0 }
          : item
      )
    );
  };

  return (
    <>
      {!isListOpen && (
        <div className="TagActivity" onClick={toggleList}>
          <div className="usable-container">
            <img src={Tag} alt="Ask-icon" className="askicon" />
            <Typography className="ask">TAG</Typography>
          </div>
          <div className="usable-container">
            <span className="number">
              {props.activityCountRes?.hashListSize}
            </span>
            <img src={DownArrow} alt="DownArrow" className="DownArrow" />
          </div>
        </div>
      )}

      {isListOpen && (
        <div className="AskActivity_active">
          <div
            className="color-combination"
            onClick={() => setisListOpen(false)}
          >
            <div className="usable-container">
              <img src={Tag} alt="Ask-icon" className="askicon" />
              <Typography className="ask">TAG</Typography>
            </div>
            <div className="usable-container">
              <span className="number">
                {props.activityCountRes?.hashListSize}
              </span>
              <img src={DownArrow} alt="DownArrow" className="DownArrow" />
            </div>
          </div>
          <div
            ref={listRef}
            onScroll={handleScroll}
            role="list"
            className="posts"
          >
            {listData && listData.length !== 0 ? (
              <ActivityPost
                listData={listData}
                updateParentComponentSayCount={updateParentComponentSayCount}
                updateMessage={updateMessage}
                delete={confirmationForDelete}
                updateList={updateList}
                filterType="activityTag"
                decreaseHashCount={props.decreaseHashCount}
                deleteActivityTagPost={deleteActivityTagPost}
                onHashTagClick={props.onHashTagClick}
                onDelete={deleteTag}
                postType={"TAG"}
                handleDeleteAttachementDocFromParent={
                  handleDeleteAttachementDocFromParent
                }
              />
            ) : (
              <div className="no-data-container">
                {activityLoading ? (
                  <CircularProgress size={25} />
                ) : (
                  <p>No Activity Hash Follows found</p>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      {/* {confModalVisible?.open && <ConfirmationDialog {...confModalVisible} />} */}
    </>
  );
}

export default TagActtivity;
